module.exports = __webpack_public_path__ + "img/bttn_AR_video.86896195.png";